export enum DataFields {
    housingType = "housingType",
    propertyStreet = "propertyStreet",
    propertyNumber = "propertyNumber",
    propertyLetterBox = "propertyLetterBox",
    propertyPostalCode = "propertyPostalCode",
    propertyCity = "propertyCity",
    brokerData = "brokerData",
    yourInformationFirstName = "yourInformationFirstName",
    yourInformationLastName = "yourInformationLastName",
    yourInformationEmail = "yourInformationEmail",
    yourInformationPhone = "yourInformationPhone",
    yourInformationQuestion = "yourInformationQuestion",
    yourInformationConsent = "yourInformationConsent",
    propertyRisk = "propertyRisk",
    totalRoomCount = "totalRoomCount",
    insurance = "insurance",
    totalPrice = "totalPrice",
    isTheftChecked = "isTheftChecked",
    isLegalChecked = "isLegalChecked",
    isPackageChecked = "isPackageChecked",
    chosenTheftOption = "chosenTheftOption",
    weTakeCareActivated = "weTakeCareActivated",
    weTakeCareStepout = "weTakeCareStepout",
    weTakeCareReason = "weTakeCareReason",
    flowFinished = "flowFinished",
    thankYouData = "thankYouData",
}

export enum PageNames {
    Welcome = "Welcome",
    FlowChoice = "FlowChoice",
    PropertyDescription = "PropertyDescription",
    PropertyAddress = "PropertyAddress",
    PropertySpaces = "PropertySpaces",
    InsuranceChoice = "InsuranceChoice",
    AdditionalCovers = "AdditionalCovers",
    BrokerSearch = "BrokerSearch",
    YourInformation = "YourInformation",
    ThankYou = "ThankYou",
    WeTakeCare = "WeTakeCare",
    TechnicalDifficulties = "TechnicalDifficulties",
    Baloise = "https://www.baloise.be/",
}

export enum FlowTypes {
    Tenant = "Tenant",
    Owner = "Owner",
    Generic = "Generic",
}

export enum UserType {
    Owner = "Owner",
    Tenant = "Tenant",
}

export enum RoomTypes {
    basic = "basic",
    others = "others",
    attics = "attics",
    garages = "garages",
    cellars = "cellars",
    extras = "extras",
}

export enum GetTariffParameterObjectBuildingType {
    Open = "Open",
    HalfOpenOrClosed = "HalfOpenOrClosed",
    Apartment = "Apartment",
}

export enum WtcReasonBusinessRule {
    RiskLevel = "RiskLevel",
    NumberOfRoomsTooLow = "NumberOfRoomsTooLow",
    NumberOfRoomsTooHigh = "NumberOfRoomsTooHigh",
}
export enum WtcReasonPage {
    PropertyDescription = "PropertyDescription",
    PropertyAddress = "PropertyAddress",
    PropertySpaces = "PropertySpaces",
}
export enum WtcReasonReason {
    BusinessRule = "BusinessRule",
    UserExit = "UserExit",
}

export enum FireLeadRequestBodyV2LeadType {
    QuoteLead = "QuoteLead",
    WtcMin = "WtcMin",
}

export declare enum GetTariffParameterObjectResidentType {
    Owner = "Owner",
    Tenant = "Tenant",
}
